// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quotation-figma-dropdown {
  position: relative;
  width: 100%;
  min-width: 0;
  font-family: var(--font-family-primary, "Lexend", sans-serif);
}

.quotation-figma-dropdown.dark {
  background: transparent !important;
}

.quotation-figma-dropdown.is-open {
  z-index: 120;
}

.quotation-figma-dropdown-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  height: 40px;
  padding: 0 10px 0 12px;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: var(--radius-md, 10px);
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 14px;
  font-weight: 400;
  line-height: 21.7px;
  text-align: left;
  cursor: pointer;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.quotation-figma-dropdown-trigger:hover {
  border-color: var(--text-secondary, #506360);
}

.quotation-figma-dropdown.is-open .quotation-figma-dropdown-trigger,
.quotation-figma-dropdown-trigger:focus-visible {
  border: 2px solid var(--interactive-default, #0f766e);
  padding-inline: 11px 9px;
  box-shadow: var(--field-focus-ring, 0 0 0 3px rgba(15, 186, 196, 0.22));
}

.quotation-figma-dropdown-trigger:disabled {
  border-color: var(--border-subtle, #dce3e2);
  background: var(--surface-secondary, #f4f7f7);
  color: var(--text-disabled, #8a9896);
  cursor: not-allowed;
  box-shadow: none;
}

.quotation-figma-dropdown-trigger svg {
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
  transition: transform 0.15s ease;
}

.quotation-figma-dropdown-trigger > span {
  display: block;
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.quotation-figma-dropdown.is-open .quotation-figma-dropdown-trigger svg {
  transform: rotate(180deg);
}

.quotation-figma-dropdown-menu {
  box-sizing: border-box;
  position: absolute;
  z-index: 1300 !important;
  top: calc(100% + 6px);
  left: 0;
  width: 100%;
  min-width: 160px;
  max-height: 260px;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
  scrollbar-width: thin;
  padding: 6px;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: var(--radius-md, 10px);
  background: var(--surface-primary, #fff);
  box-shadow: 0 6px 16px -4px rgba(14, 26, 32, 0.16),
    0 1px 2px rgba(14, 26, 32, 0.06);
}

.quotation-catalogue-modal .quotation-figma-dropdown-menu {
  max-height: 224px;
}

.quotation-figma-dropdown-menu::-webkit-scrollbar,
.catalogue-modal-menu-popper .quotation-figma-dropdown-menu::-webkit-scrollbar,
.quotation-catalogue-modal .quotation-figma-dropdown-menu::-webkit-scrollbar {
  width: 6px;
}

.quotation-figma-dropdown-menu::-webkit-scrollbar-thumb,
.catalogue-modal-menu-popper
  .quotation-figma-dropdown-menu::-webkit-scrollbar-thumb,
.quotation-catalogue-modal
  .quotation-figma-dropdown-menu::-webkit-scrollbar-thumb {
  border-radius: 999px;
  background: var(--border-default, #cdd6d4);
}

.quotation-catalogue-row:last-child .quotation-figma-dropdown-menu {
  top: auto;
  bottom: calc(100% + 6px);
}

.quotation-figma-dropdown-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  min-height: 36px;
  padding: 8px 10px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: var(--text-primary, #142624);
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  cursor: pointer;
  outline: none;
}

.quotation-figma-dropdown-option:hover,
.quotation-figma-dropdown-option.is-selected,
.quotation-figma-dropdown-option:focus-visible {
  background: var(--interactive-soft, #f0f8f7);
  color: var(--interactive-default, #0f766e);
}

.quotation-figma-dropdown-option:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: -2px;
}

.quotation-figma-dropdown-option:disabled {
  color: var(--text-disabled, #8a9896);
  cursor: not-allowed;
}

.quotation-figma-dropdown-option svg {
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
}

.quotation-figma-dropdown-option > span {
  min-width: 0;
  overflow-wrap: anywhere;
}

.quotation-figma-dropdown-option > .themed-select-option-status {
  flex: 0 0 auto;
  margin-left: auto;
  color: var(--text-secondary);
  font-size: var(--font-size-body-xs);
  font-weight: var(--font-weight-regular);
  white-space: nowrap;
  text-align: right;
}

.quotation-figma-dropdown.dark .quotation-figma-dropdown-trigger,
.quotation-editor-shell.dark .quotation-figma-dropdown-trigger,
.invoice-flow-shell.dark .quotation-figma-dropdown-trigger,
.quotation-figma-dropdown.dark .quotation-figma-dropdown-menu,
.quotation-editor-shell.dark .quotation-figma-dropdown-menu,
.invoice-flow-shell.dark .quotation-figma-dropdown-menu {
  border-color: var(--border-default, #3a3f47);
  background: var(--surface-primary, #191b1f);
  color: var(--text-primary, #f2f3f5);
}

.quotation-figma-dropdown.dark .quotation-figma-dropdown-option,
.quotation-editor-shell.dark .quotation-figma-dropdown-option,
.invoice-flow-shell.dark .quotation-figma-dropdown-option {
  color: var(--text-primary, #f2f3f5);
}

.quotation-figma-dropdown.dark .quotation-figma-dropdown-option:hover,
.quotation-figma-dropdown.dark .quotation-figma-dropdown-option.is-selected,
.quotation-figma-dropdown.dark .quotation-figma-dropdown-option:focus-visible,
.quotation-editor-shell.dark .quotation-figma-dropdown-option:hover,
.quotation-editor-shell.dark .quotation-figma-dropdown-option.is-selected,
.quotation-editor-shell.dark .quotation-figma-dropdown-option:focus-visible,
.invoice-flow-shell.dark .quotation-figma-dropdown-option:hover,
.invoice-flow-shell.dark .quotation-figma-dropdown-option.is-selected,
.invoice-flow-shell.dark .quotation-figma-dropdown-option:focus-visible {
  background: rgba(67, 167, 156, 0.15);
  color: var(--interactive-default, #43a79c);
}

.quotation-figma-dropdown.dark .quotation-figma-dropdown-trigger:hover,
.quotation-editor-shell.dark .quotation-figma-dropdown-trigger:hover,
.invoice-flow-shell.dark .quotation-figma-dropdown-trigger:hover {
  border-color: var(--text-secondary, #b3b8c2);
}

.quotation-figma-dropdown.dark .quotation-figma-dropdown-trigger:disabled,
.quotation-editor-shell.dark .quotation-figma-dropdown-trigger:disabled,
.invoice-flow-shell.dark .quotation-figma-dropdown-trigger:disabled {
  border-color: var(--border-subtle, #2c3036);
  background: var(--surface-secondary, #22252a);
  color: var(--text-disabled, #8a9896);
}
`, "",{"version":3,"sources":["webpack://./src/components/FormControls/themedSelect.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,6DAA6D;AAC/D;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,gDAAgD;EAChD,qCAAqC;EACrC,wCAAwC;EACxC,mCAAmC;EACnC,6DAA6D;EAC7D,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,0DAA0D;AAC5D;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;;EAEE,qDAAqD;EACrD,wBAAwB;EACxB,uEAAuE;AACzE;;AAEA;EACE,2CAA2C;EAC3C,6CAA6C;EAC7C,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,wBAAwB;EACxB,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,wBAAwB;EACxB,qBAAqB;EACrB,YAAY;EACZ,+CAA+C;EAC/C,qCAAqC;EACrC,wCAAwC;EACxC;oCACkC;AACpC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;;;;;EAKE,oBAAoB;EACpB,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,mCAAmC;EACnC,6DAA6D;EAC7D,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,aAAa;AACf;;AAEA;;;EAGE,4CAA4C;EAC5C,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,4BAA4B;EAC5B,mCAAmC;EACnC,uCAAuC;EACvC,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;;;;;EAME,4CAA4C;EAC5C,2CAA2C;EAC3C,mCAAmC;AACrC;;AAEA;;;EAGE,mCAAmC;AACrC;;AAEA;;;;;;;;;EASE,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;;;EAGE,4CAA4C;AAC9C;;AAEA;;;EAGE,2CAA2C;EAC3C,6CAA6C;EAC7C,oCAAoC;AACtC","sourcesContent":[".quotation-figma-dropdown {\n  position: relative;\n  width: 100%;\n  min-width: 0;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n}\n\n.quotation-figma-dropdown.dark {\n  background: transparent !important;\n}\n\n.quotation-figma-dropdown.is-open {\n  z-index: 120;\n}\n\n.quotation-figma-dropdown-trigger {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  width: 100%;\n  height: 40px;\n  padding: 0 10px 0 12px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: var(--radius-md, 10px);\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 21.7px;\n  text-align: left;\n  cursor: pointer;\n  outline: none;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.quotation-figma-dropdown-trigger:hover {\n  border-color: var(--text-secondary, #506360);\n}\n\n.quotation-figma-dropdown.is-open .quotation-figma-dropdown-trigger,\n.quotation-figma-dropdown-trigger:focus-visible {\n  border: 2px solid var(--interactive-default, #0f766e);\n  padding-inline: 11px 9px;\n  box-shadow: var(--field-focus-ring, 0 0 0 3px rgba(15, 186, 196, 0.22));\n}\n\n.quotation-figma-dropdown-trigger:disabled {\n  border-color: var(--border-subtle, #dce3e2);\n  background: var(--surface-secondary, #f4f7f7);\n  color: var(--text-disabled, #8a9896);\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.quotation-figma-dropdown-trigger svg {\n  width: 16px;\n  height: 16px;\n  flex: 0 0 16px;\n  transition: transform 0.15s ease;\n}\n\n.quotation-figma-dropdown-trigger > span {\n  display: block;\n  flex: 1 1 auto;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.quotation-figma-dropdown.is-open .quotation-figma-dropdown-trigger svg {\n  transform: rotate(180deg);\n}\n\n.quotation-figma-dropdown-menu {\n  box-sizing: border-box;\n  position: absolute;\n  z-index: 1300 !important;\n  top: calc(100% + 6px);\n  left: 0;\n  width: 100%;\n  min-width: 160px;\n  max-height: 260px;\n  overflow-x: hidden;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  scrollbar-gutter: stable;\n  scrollbar-width: thin;\n  padding: 6px;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: var(--radius-md, 10px);\n  background: var(--surface-primary, #fff);\n  box-shadow: 0 6px 16px -4px rgba(14, 26, 32, 0.16),\n    0 1px 2px rgba(14, 26, 32, 0.06);\n}\n\n.quotation-catalogue-modal .quotation-figma-dropdown-menu {\n  max-height: 224px;\n}\n\n.quotation-figma-dropdown-menu::-webkit-scrollbar,\n.catalogue-modal-menu-popper .quotation-figma-dropdown-menu::-webkit-scrollbar,\n.quotation-catalogue-modal .quotation-figma-dropdown-menu::-webkit-scrollbar {\n  width: 6px;\n}\n\n.quotation-figma-dropdown-menu::-webkit-scrollbar-thumb,\n.catalogue-modal-menu-popper\n  .quotation-figma-dropdown-menu::-webkit-scrollbar-thumb,\n.quotation-catalogue-modal\n  .quotation-figma-dropdown-menu::-webkit-scrollbar-thumb {\n  border-radius: 999px;\n  background: var(--border-default, #cdd6d4);\n}\n\n.quotation-catalogue-row:last-child .quotation-figma-dropdown-menu {\n  top: auto;\n  bottom: calc(100% + 6px);\n}\n\n.quotation-figma-dropdown-option {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  width: 100%;\n  min-height: 36px;\n  padding: 8px 10px;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--text-primary, #142624);\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  text-align: left;\n  cursor: pointer;\n  outline: none;\n}\n\n.quotation-figma-dropdown-option:hover,\n.quotation-figma-dropdown-option.is-selected,\n.quotation-figma-dropdown-option:focus-visible {\n  background: var(--interactive-soft, #f0f8f7);\n  color: var(--interactive-default, #0f766e);\n}\n\n.quotation-figma-dropdown-option:focus-visible {\n  outline: 2px solid var(--focus-ring);\n  outline-offset: -2px;\n}\n\n.quotation-figma-dropdown-option:disabled {\n  color: var(--text-disabled, #8a9896);\n  cursor: not-allowed;\n}\n\n.quotation-figma-dropdown-option svg {\n  width: 16px;\n  height: 16px;\n  flex: 0 0 16px;\n}\n\n.quotation-figma-dropdown-option > span {\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n\n.quotation-figma-dropdown-option > .themed-select-option-status {\n  flex: 0 0 auto;\n  margin-left: auto;\n  color: var(--text-secondary);\n  font-size: var(--font-size-body-xs);\n  font-weight: var(--font-weight-regular);\n  white-space: nowrap;\n  text-align: right;\n}\n\n.quotation-figma-dropdown.dark .quotation-figma-dropdown-trigger,\n.quotation-editor-shell.dark .quotation-figma-dropdown-trigger,\n.invoice-flow-shell.dark .quotation-figma-dropdown-trigger,\n.quotation-figma-dropdown.dark .quotation-figma-dropdown-menu,\n.quotation-editor-shell.dark .quotation-figma-dropdown-menu,\n.invoice-flow-shell.dark .quotation-figma-dropdown-menu {\n  border-color: var(--border-default, #3a3f47);\n  background: var(--surface-primary, #191b1f);\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-figma-dropdown.dark .quotation-figma-dropdown-option,\n.quotation-editor-shell.dark .quotation-figma-dropdown-option,\n.invoice-flow-shell.dark .quotation-figma-dropdown-option {\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-figma-dropdown.dark .quotation-figma-dropdown-option:hover,\n.quotation-figma-dropdown.dark .quotation-figma-dropdown-option.is-selected,\n.quotation-figma-dropdown.dark .quotation-figma-dropdown-option:focus-visible,\n.quotation-editor-shell.dark .quotation-figma-dropdown-option:hover,\n.quotation-editor-shell.dark .quotation-figma-dropdown-option.is-selected,\n.quotation-editor-shell.dark .quotation-figma-dropdown-option:focus-visible,\n.invoice-flow-shell.dark .quotation-figma-dropdown-option:hover,\n.invoice-flow-shell.dark .quotation-figma-dropdown-option.is-selected,\n.invoice-flow-shell.dark .quotation-figma-dropdown-option:focus-visible {\n  background: rgba(67, 167, 156, 0.15);\n  color: var(--interactive-default, #43a79c);\n}\n\n.quotation-figma-dropdown.dark .quotation-figma-dropdown-trigger:hover,\n.quotation-editor-shell.dark .quotation-figma-dropdown-trigger:hover,\n.invoice-flow-shell.dark .quotation-figma-dropdown-trigger:hover {\n  border-color: var(--text-secondary, #b3b8c2);\n}\n\n.quotation-figma-dropdown.dark .quotation-figma-dropdown-trigger:disabled,\n.quotation-editor-shell.dark .quotation-figma-dropdown-trigger:disabled,\n.invoice-flow-shell.dark .quotation-figma-dropdown-trigger:disabled {\n  border-color: var(--border-subtle, #2c3036);\n  background: var(--surface-secondary, #22252a);\n  color: var(--text-disabled, #8a9896);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
